/**
 * features/suppliers/use-supplier-search.ts — ค้นหาผู้ขายแบบ autocomplete สำหรับใช้ในฟอร์มค่าใช้จ่าย
 */

import { useQuery } from '@tanstack/react-query';
import { api, queryString } from '~/lib/api';
import type { Paginated, Party } from '~/lib/types';

export function useSupplierSearch(search: string) {
  return useQuery({
    queryKey: ['suppliers', 'search', search],
    queryFn: () =>
      api.get<Paginated<Party>>(
        `/api/suppliers${queryString({ page: 1, pageSize: 8, search })}`,
      ),
    enabled: search.trim().length > 0,
  });
}
